import { getPropositions, getAdobeTargetJsonOffer } from '@rei/adobe-target-functions';

const AdobeTarget = {
  /**
   * Provides an array of Adobe Target experiences based on the test cases
   * @param {string[]} options - The Adobe Target options array. Example: ['adobe-test-1', 'adobe-test-2']
   * @returns {Promise<any>} An array containing the loaded Adobe Target experiences
   */
  async get(options) {
    try {
      if (!options) {
        throw new Error('No options were provided');
      }

      if (typeof window?.alloy === 'function') {
        const experiences = await getPropositions(options);

        if (experiences && experiences.length) {
          const [{ content }] = experiences;
          const [values] = content;
          return values;
        }

        throw new Error('No experiences found');
      }

      if (window?.adobe?.target) {
        const experiences = await getAdobeTargetJsonOffer(...options);

        if (experiences && experiences.length) {
          const [{ content }] = experiences;
          const [[values]] = content;
          return values;
        }

        throw new Error('No experiences found');
      }

      console.error('Both alloy and at.js are undefined');
      throw new Error('Both alloy and at.js are undefined');
    } catch (error) {
      return null;
    }
  },
};

export default AdobeTarget;
